(function () {
  'use strict';

  async function fetchDoc(url) {
    const res = await fetch(url);
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function updateCount(grid) {
    const countEl = document.querySelector('[data-collection-count]');
    if (!countEl) return;
    const totalItems = grid.querySelectorAll(':scope > *').length;
    const match = countEl.textContent.match(/of\s([\d,]+)/);
    const total = match ? match[1] : '';
    countEl.textContent = `1–${totalItems} of ${total} products`;
  }

  function initShowMore() {
    const btn = document.querySelector('[data-show-more]');
    if (!btn) return;

    btn.addEventListener('click', async function (e) {
      e.preventDefault();

      const url = btn.getAttribute('href');
      const grid = document.querySelector('[data-collection-grid]');
      if (!grid || !url) return;

      btn.classList.add('is-loading');
      btn.textContent = 'Loading...';

      try {
        const doc = await fetchDoc(url);

        doc.querySelectorAll('[data-collection-grid] > *').forEach(item => {
          grid.appendChild(item);
        });

        updateCount(grid);

        const nextBtn = doc.querySelector('[data-show-more]');
        if (nextBtn) {
          btn.setAttribute('href', nextBtn.getAttribute('href'));
          btn.classList.remove('is-loading');
          btn.textContent = 'Show more';
        } else {
          btn.closest('.pagination--show-more').remove();
        }

      } catch (err) {
        console.error('[ShowMore] Failed:', err);
        btn.classList.remove('is-loading');
        btn.textContent = 'Show more';
      }
    });
  }

  function initInfiniteScroll() {
    const sentinel = document.querySelector('[data-infinite-scroll]');
    if (!sentinel) return;

    let loading = false;

    const observer = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting || loading) return;

      const url = sentinel.getAttribute('data-next-url');
      const grid = document.querySelector('[data-collection-grid]');
      if (!url || !grid) return;

      loading = true;
      sentinel.classList.add('is-loading');

      try {
        const doc = await fetchDoc(url);

        doc.querySelectorAll('[data-collection-grid] > *').forEach(item => {
          grid.appendChild(item);
        });

        updateCount(grid);

        const nextSentinel = doc.querySelector('[data-infinite-scroll]');
        if (nextSentinel) {
          sentinel.setAttribute('data-next-url', nextSentinel.getAttribute('data-next-url'));
          sentinel.classList.remove('is-loading');
          loading = false;
        } else {
          observer.disconnect();
          sentinel.remove();
        }

      } catch (err) {
        console.error('[InfiniteScroll] Failed:', err);
        sentinel.classList.remove('is-loading');
        loading = false;
      }
    }, {
      rootMargin: '200px'
    });

    observer.observe(sentinel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initShowMore();
    initInfiniteScroll();
  });

})();